<template>
  <div>
    <div class="perspective-definition-form">
      <div class="modal-body">
        <base-input
          v-model="formItems.name"
          inputType="text"
          labelText="Adı"
          id="name"
          name="name"
          class="form-control"
          :class="{ 'is-invalid': submitted && $v.formItems.name.$error }"
        />
        <div
          v-if="submitted && !$v.formItems.name.required"
          class="invalid-feedback"
        >
          {{ invalidMessage }}
        </div>
        <base-input
          v-model="formItems.depth"
          inputType="number"
          labelText="Derinlik"
          id="nadepthe"
          name="depth"
          class="form-control"
          :class="{ 'is-invalid': submitted && $v.formItems.depth.$error }"
        />
        <base-input
          v-model="formItems.shortContent"
          inputType="text"
          labelText="Kısa Tanım"
          id="shortContent"
          name="shortContent"
        />
        <base-input
          v-model="formItems.description"
          inputType="text"
          labelText="Açıklama"
          id="description"
          name="description"
        />
      </div>
      <div class="modal-bottom">
        <base-button class="giveUp" @click="$modal.hide('modal')"
          >Vazgeç</base-button
        >
        <base-button @click="sendForm" class="add"> Kaydet </base-button>
      </div>
    </div>
  </div>
</template>
<script>
import { BaseInput, BaseButton } from "@/components";
import { required, numeric, minValue } from "vuelidate/lib/validators";

export default {
  name: "PerspectiveDefinitionForm",
  props: {
    clickedNewItemBtn: Boolean,
    id: Number,
    selectedDataId: Number,
    selectedDataName: String,
    selectedDataDepth: Number,
    selectedShortContent: String,
    selectedDescription: String,
    shortContent: String,
    description: String,
    selectedDataOrder: Number,
    InsertUpdateForm: {
      type: Function,
    },
  },
  data() {
    return {
      invalidMessage: "Bu alan boş bırakılamaz!",
      submitted: false,
      clickedNewBtn: this.clickedNewItemBtn,
      formItems: {
        id: this.selectedDataId,
        name: this.selectedDataName,
        depth: this.selectedDataDepth,
        shortContent: this.selectedShortContent,
        description: this.selectedDescription,
        order: this.selectedDataOrder,
      },
    };
  },
  validations: {
    formItems: {
      name: { required },
      depth: { required, numeric, minValue: minValue(0) },
    },
  },
  methods: {
    sendForm() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.clickedNewItemBtn) {
        delete this.formItems.id;
        delete this.formItems.order;
      }
      this.formItems.depth = Number(this.formItems.depth);
      this.$emit("submit-form", this.formItems);
    },
  },
  components: {
    BaseInput,
    BaseButton,
  },
};
</script>
<style lang="scss">
.invalid-feedback {
  color: red;
  font-size: 12px;
  margin-top: 5px;
  padding-left: 10px;
}
.is-invalid {
  input {
    border: 1px solid red !important;
  }
}
</style>
